import type { LogEventFunc } from 'bc-metrics';
import { metrics } from 'bc-metrics';
import { getRouteContext } from './getRouteContext';

/**
 * Wrapper method for `metrics.logEvent()` that automatically includes the current route context.
 */
const logClientEvent: LogEventFunc = (data): void => {
  const routeContext = getRouteContext();

  const definedContext = Object.fromEntries(
    Object.entries(routeContext).filter(([, value]) => value !== undefined)
  );

  metrics.logEvent({
    ...definedContext,
    ...data,
  });
};

export { logClientEvent };
